// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__5gN3D","col":"styles_col__2s0Kk"};